// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","servicesSection":"Hero_servicesSection__z6iL-"};